import { Link } from 'react-router-dom';
import { Logo } from '@/components/Logo';

const COLUMNS: { heading: string; links: { label: string; to: string }[] }[] = [
  {
    heading: 'Watch',
    links: [
      { label: 'Browse', to: '/browse' },
      { label: 'My List', to: '/my-list' },
      { label: 'Search', to: '/search' },
      { label: 'Plans', to: '/plans' },
    ],
  },
  {
    heading: 'Explore',
    links: [
      { label: 'Games', to: '/games' },
      { label: 'Store', to: '/store' },
      { label: 'Dev Forums', to: '/dev' },
    ],
  },
  {
    heading: 'Account',
    links: [
      { label: 'Sign in', to: '/login' },
      { label: 'Sign up', to: '/signup' },
      { label: 'Your account', to: '/account' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About', to: '/about' },
      { label: 'Help', to: '/help' },
      { label: 'Accessibility', to: '/accessibility' },
    ],
  },
];

export function Footer() {
  return (
    <footer className="mt-auto border-t border-border bg-panel">
      <div className="container-page grid gap-10 py-12 md:grid-cols-[1.4fr_repeat(4,1fr)]">
        <div className="space-y-4">
          <Logo />
          <p className="max-w-xs text-sm text-ink-muted">
            The streaming home of Nullify Entertainment originals — every show in Japanese and
            English audio.
          </p>
        </div>
        {COLUMNS.map((col) => (
          <nav key={col.heading} aria-label={col.heading} className="space-y-3">
            <h2 className="text-2xs font-semibold uppercase tracking-[0.16em] text-ink-faint">
              {col.heading}
            </h2>
            <ul className="space-y-2">
              {col.links.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-ink-muted transition-colors hover:text-ink"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>
      <div className="border-t border-border">
        <div className="container-page flex flex-col items-center justify-between gap-3 py-6 text-xs text-ink-faint sm:flex-row">
          <p>© {new Date().getFullYear()} Nullify Entertainment. BingeBox™</p>
          <nav className="flex flex-wrap items-center gap-x-4 gap-y-1" aria-label="Legal">
            <Link to="/terms" className="hover:text-ink">Terms</Link>
            <Link to="/privacy" className="hover:text-ink">Privacy</Link>
            <Link to="/cookies" className="hover:text-ink">Cookie Choices</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
